
import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Typography, Divider} from 'views/components';
import {UploadFileToS3, SecureFileGrid, Translate} from 'views/module';
import {CloudUpload, DeleteForever} from 'views/icons';


const ContentEdit = (props) => {
  const bioQuestion = props.bioQuestion;
  const updateQuestionData = props.updateQuestionData;
  const getSignedFileUrl = props.getSignedFileUrl;
  const extraFileMenuItems = props.extraFileMenuItems;

  const {bioQuestionId, questionData} = bioQuestion;

  const filesExist = Boolean(questionData.value.length);

  const getSignedUrl = async (file) => {
    return getSignedFileUrl(bioQuestionId, file, questionData.isPublic, (fileUrl) => {
      const newFile = {
        name: file.name,
        type: file.type,
        src: fileUrl,
      };
      updateQuestionData((prev) => ({
        value: [...prev.value, newFile],
        isPublic: prev.isPublic,
      }));
    });
  };

  const handleDelete = (deletedFile) => {
    updateQuestionData((prev) => ({
      value: prev.value.filter((file) => file.src !== deletedFile.src),
      isPublic: prev.isPublic,
    }));
  };

  return (
    <Box
      position='relative'
      sx={{
        'padding': 2,
        'border': '1px solid rgba(0,0,0, 0.23)',
        'borderRadius': '4px',
      }}
    >
      <Typography
        sx={{
          position: 'absolute',
          backgroundColor: 'white',
          top: 0,
          left: 0,
          transform: 'translate(-5%, -50%) scale(0.75)',
          color: 'rgba(0,0,0,0.6)',
          px: 1,
        }}
      >
        <Translate expression={`caregiver.CaregiverDetail.Biography.Questions.Titles.${bioQuestionId}`} />
      </Typography>
      <Stack
        spacing={1}
      >

        <UploadFileToS3
          getSignedUrl={
            getSignedUrl
          }
        >
          <Box
            sx={{
              'width': '100%',
              'height': '150px',
              'border': '1px solid rgba(0,0,0, 0.23)',
              'borderRadius': '10px',
              'cursor': 'pointer',
            }}
          >
            <Stack
              sx={{
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                mb: '10px',
              }}
            >
              <CloudUpload color='action' fontSize='large' />
              <Typography color='action'>
                <Translate expression='caregiver.CaregiverDetail.Biography.EditQuestion.File.UploadFile' />
              </Typography>
            </Stack>
          </Box>
        </UploadFileToS3>
        {
          filesExist && (
            <>
              <Divider
                sx={{
                  paddingTop: 2,
                }}
              />
              <SecureFileGrid
                files={questionData.value}
                menuItems={[
                  {
                    Icon: DeleteForever,
                    text: 'Delete',
                    handler: handleDelete,
                  },
                  ...extraFileMenuItems,
                ]}
              />
            </>
          )
        }
      </Stack>
    </Box>
  );
};

ContentEdit.propTypes = {
  bioQuestion: PropTypes.shape({
    bioQuestionId: PropTypes.string.isRequired,
    questionData: PropTypes.shape({
      value: PropTypes.array.isRequired,
      isPublic: PropTypes.bool,
    }).isRequired,
  }).isRequired,
  getSignedFileUrl: PropTypes.func.isRequired,
  updateQuestionData: PropTypes.func.isRequired,
  extraFileMenuItems: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    handler: PropTypes.func.isRequired,
    Icon: PropTypes.elementType,
    condition: PropTypes.func,
  })),
};

export default ContentEdit;
